<template>
  <div class="item-details details-wrap">
    <h4 class="item-details__title">
      item
      <span> {{ idx +1  }} </span>
    </h4>
    <div class="item-details__items-wrap">
      <div class="item-details__side item-details__side--left">
        <div class="details-wrap--1">
          <h5 class="details-wrap__title">Order Details</h5>
          <div class="details-inputs details-inputs">
            <label class="details-inputs__label">Internal Number:</label>
            <input type="text" class="details-inputs__input" v-model="itemDetail.itemserial"/>
          </div>
          <div class="details-inputs">
            <label class="details-inputs__label">SKU:</label>
            <input type="text" class="details-inputs__input" v-model="itemDetail.sku" />
          </div>
          <div class="details-inputs">
            <label class="details-inputs__label">Product:</label>
            <input type="text" class="details-inputs__input" v-model="itemDetail.pname" />
          </div>
          <div class="details-inputs">
            <label class="details-inputs__label">Size:</label>
            <input type="text" class="details-inputs__input" v-model="itemDetail.size"/>
          </div>
          <div class="details-inputs">
            <label class="details-inputs__label">Site Alloc:</label>
            <input type="text" class="details-inputs__input" v-model="itemDetail.site"/>
          </div>
          <div class="details-inputs">
            <label class="details-inputs__label">Job Sheet Link:</label>
            <a href class="details-inputs__link" target="_blank">Download Job Sheet</a>
          </div>
          <div class="details-inputs">
			<label class="details-inputs__label">Irregular Report:</label>
			<button @click="isShow = !isShow">Err Reporting</button>
			
			<div class="modal" v-show="isShow">

  <div class="content">
	
    <form>
      <label id="err_order_serial">Item Number:</label>
      <input type="text" name="item_serial" id="err_order_serial" v-model="itemDetail.itemserial" readonly>
      <br>
      Problem type: 
		<select name="typecode" v-model="errortype">
		<option value="error|address|invalid_name">Address: Invalid name</option>
		<option value="error|address|invalid_street1">Address: Invalid Address Line 1</option>
		<option value="error|address|invalid_street2">Address: Invalid Address Line 2</option>
		<option value="error|address|invalid_postcode">Address: Invalid Post Code</option>
		<option value="error|address|invalid_country_code">Address: Invalid Country Code</option>
		<option value="error|address|invalid_phone">Address: Invalid Phone Number</option>
		<option value="error|address|invalid_email">Address: Invalid Email</option>
		<option value="error|address|other">Address: Invalid Other</option>
		<option value="error|shipping|incompatible_shipping_method">Shipping: Invalid Shipping Method</option>
		<option value="error|artwork|">Artwork</option>
		<option value="error|product|">Product</option>
		</select>
		<br><br>
		Problem descrption: <input type="text" name="message"  v-model="errormsg" size=50>
    </form>
	
  </div>
  <div class="footer">
    <button type="submit" @click="submitError">Submit</button>
    <button class="cancel" @click="isShow = false">Close</button>
  </div>

</div>
			
			
			
          </div>
			

        </div>
        <div class="details-wrap details-wrap--2">
          <h5 class="details-wrap__title">Historical Record</h5>
          <table class="details-table">
            <thead>
              <tr>
                <th>Status</th>
                <th>Author</th>
                <th>time</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="track in itemDetail.tracking"  v-bind:key="track.track_serial" >
                <td>{{ track.process }}</td>
                <td>{{ track.start_handler }}</td>
                <td>{{ track.startdt }}</td>
              </tr>
              
            </tbody>
          </table>
        </div>
      </div>
      <div class="item-details__side item-details__side--right">
        <a :href="itemDetail.thumbpath" target="_blank"><img :src="itemDetail.thumbpath" alt class /></a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  props: {
    itemDetail: {
      type: Object
    },
	idx: {
      type: Number
	}
	
  },
  methods: {
    roleCount(key) {
      return key + 1;
    },
	
	submitError() {
		axios.post('https://new.colorwayrb.com/backend/ajax_err_report.php?sessionid=' + this.$store.getters.sessionid, {
			item_serial: this.itemDetail.itemserial,
			typecode: this.errortype,
			message: this.errormsg,
			
		}).then(response => {
				
				alert(response.data);
				this.isShow = false;
				
			});
	}
	
  },
  name: "ItemsDetails",
  components: {
            
        },
  data: function(){
                return{
                    isShow: false,
					errortype: "",
					errormsg: "",
                }
            }
});
</script>

<style lang="scss" scoped>
.item-details {
  background-color: $color8;
  border: 1px solid $border-color;
  padding: 10px 20px;
  margin-bottom: 20px;
  border-radius: 5px;
  margin-right: 7px;

  &__items-wrap {
    display: flex;
    justify-content: space-between;
    padding: 5px;

    img {
      border-radius: 10px;
      max-width: 250px;
    }
  }

  &__title {
    padding: 0 10px;
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    border-bottom: 1px solid $border-color;
    margin-bottom: 10px;
    text-transform: uppercase;
  }

  &__side--left {
    width: 445px;
  }

  &__side--right {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.details-wrap {
  &--1 {
    margin-bottom: 15px;
  }

  &__title {
    text-align: center;
    text-decoration-line: underline;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    text-transform: uppercase;
    margin-bottom: 10px;
  }
}

.details-inputs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 0;

  &__link {
    box-shadow: 1px 1px 1px $border-color;
    color: $color1;
    background-color: $color2;
    text-align: center;
    font-weight: 500;
    padding: 5px 0;
    font-size: 12px;
    width: 217px;
  }

  &__label {
    font-size: 14px;
  }

  &__input {
    padding: 2px 10px;
    width: (215px - 20px);
    font-size: 14px;
    background-color: transparent;
    border: 1px solid rgba($border-color, 0.2);

    &::placeholder {
      color: black;
    }
  }
}

.details-table {
  th,
  td {
    border: 1px solid rgba($border-color, 0.2);
    text-align: center;
  }

  th {
    background-color: $color7;
    text-transform: uppercase;
    font-size: 13px;
    padding: 5px 0;
  }

  td {
    background-color: $table-light-bg;
    font-size: 13px;
    padding: 5px 0;
  }

  th:nth-child(1) {
    width: 120px;
  }
  th:nth-child(2) {
    width: 120px;
  }
  th:nth-child(3) {
    width: 200px;
  }
}


.modal{
  top: 0;
  min-width: 250px;
  width: 80%;
  height: 400px;
  margin: 0 auto;
  position: fixed;
  z-index: 40001;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 10px #000;
  margin-top: 30px;
  margin-left: 10%;

  animation-name: fadeIn_Modal;
  animation-duration: 0.8s;
 
}


</style>